(function ($) {
	class W4D_Newsletter {
		constructor() {
			this.initSelectors();
			this.bindEvents();
		}

		initSelectors() {
			this.$form = $('#form-newsletter');
		}

		bindEvents() {
			this.formValidator = this.$form.validate({
				submitHandler: (form) => {
					this.handleSubmit(form);
				},
			});
		}

		handleSubmit(form) {
			const fd = new FormData(form);

			fd.append('action', 'w4d_handle_newsletter_submission');
			fd.append('nonce', w4d_frontend_ajax.nonce);

			$.post({
				url: w4d_frontend_ajax.ajax_url,
				data: fd,
				processData: false,
				contentType: false,
				success: (response) => {
					if (response.success) {
						this.clearFormState();
						W4D_Toast.showToast('success', response.data.message);
					} else {
						if (response.data.require_login) {
							this.clearFormState();
						} else {
							W4D_Toast.showToast('error', response.data.message);
						}
					}
				},
				error: () => {
					W4D_Toast.showToast('error', 'Došlo je do pogreške u pretplati. Pokušajte ponovno.');
				},
			});
		}

		clearFormState() {
			this.formValidator.resetForm();
			this.$form[0].reset();
		}
	}

	$(document).ready(() => {
		new W4D_Newsletter();
	});
})(jQuery);
